import { RootContainer } from '../../../../core/root_container';
import { ItemRequestJsEnv } from '../../models/item_request_js_env';
import { Button } from '../button';
import {
  makerNameLenCount,
  productNameLenCount,
  makerModelLenCount,
  jancodeLenCount,
  commentLenCount
} from '../input';
import { ItemRequestAction } from '../../actions/item_request_action';

import { SendSuccess } from '../success';
import { SendFailed } from '../failed';
import { ItemRequestSubmitAction } from '../../actions/item_request_submit_action';

export class ItemRequestContainer extends RootContainer<ItemRequestJsEnv> {
  constructor(model: ItemRequestJsEnv) {
    super();
    this.mount(Button, 'js-item-request-button');
    this.mount(SendSuccess, 'js-item-request-success');
    this.mount(SendFailed, 'js-item-request-failed');
    this.mount(makerNameLenCount, 'js-item-request-makername');
    this.mount(productNameLenCount, 'js-item-request-productname');
    this.mount(makerModelLenCount, 'js-item-request-makermodel');
    this.mount(jancodeLenCount, 'js-item-request-jancode');
    this.mount(commentLenCount, 'js-item-request-comment');
    this.update(model);

    document
      .querySelector('#item-request-modal-open-button')
      ?.addEventListener('click', () => ItemRequestAction.openModal());

    ItemRequestSubmitAction.UPDATE_EVENT.on((model: ItemRequestJsEnv) => {
      this.update(model);
    });
  }
}
